<template>
  <div class='container-fluid'>
    <b-row>
      <draggable v-model="task_templates" @update="updateTasksOrder" class="container-fluid">
        <transition-group>
          <TaskTemplateItem v-for="item in task_templates" :item="item" :key="item.id" @editform="editForm" @deletetemplate="deleteTemplate"/>
        </transition-group>
      </draggable>
      <TaskTemplate v-show="showForm" :task_template="task_template" :task_template_collection="task_template_collection" />
      <b-button @click="setBlankTaskTemplate" variant="primary" class="btn-action mb-3" v-b-modal.task-template>Add New Task</b-button>
    </b-row>
  </div>
</template>

<script>
import TaskTemplate from './TaskTemplate'
import TaskTemplateItem from './TaskTemplateItem'
import draggable from 'vuedraggable'
export default {
  task_template_collection_id: '',
  name: 'TaskTemplates',
  props: ['task_templates', 'task_template_collection'],
  data () {
    return {
      showForm: false,
      task_template: {}
    }
  },
  mounted () {
    this.$root.$on('taskTemplateWasAdded', (collectionId) => {
      this.showForm = false
    })
  },
  components: {
    TaskTemplate,
    TaskTemplateItem,
    draggable
  },
  methods: {
    editForm (task) {
      this.task_template = task
      this.showForm = true
    },
    updateTasksOrder () {
      var vm = this
      this.task_templates.forEach((task, index) => {
        let taskObject = task
        taskObject.order = index
        this.$http.put('/task_template_collections/' + vm.task_template_collection.id + '/task_templates/' + task.id, { task_template: taskObject })
          .then()
          .catch(e => { console.log(e) })
      })
    },
    getTemplates (collectionId) {
      var path = '/task_template_collections/' + collectionId + '/task_templates'
      this.$http.get(path)
        .then(response => this.setTemplates(response))
        .catch(e => { console.log(e) })
    },
    setTemplates (response) {
      this.task_templates = response.data
    },
    setBlankTaskTemplate () {
      this.task_template = {
        name: '',
        text: '',
        priority: 'low',
        value: '1'
      }
      this.showForm = true
    },
    deleteTemplate (id) {
      var del = confirm('Are you sure?')
      if (del === true) {
        var vm = this
        this.$http.delete('/task_template_collections/' + this.task_template_collection.id + '/task_templates/' + id)
          .then(function (response) {
            vm.deleteSuccessful()
          })
          .catch(e => { console.log(e.response) })
      }
    },
    deleteSuccessful () {
      this.$root.$emit('taskTemplateWasDeleted')
    }
  }
}
</script>

<style scoped>
</style>
<style>
.table td {
    overflow: hidden;
    white-space: normal;
    text-overflow: ellipsis;
}

table {
    table-layout: fixed;
    border-collapse: collapse;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/TaskTemplates.vue